import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'document',
  standalone: false,
})
export class DocumentPipe implements PipeTransform {
  transform(value: string | number | undefined, includeType = false): string {
    if (!value) return '';

    const cleanValue = value.toString().replace(/\D/g, '');

    if (cleanValue.length === 11) {
      // Formata como CPF: 000.000.000-00
      const formattedCPF = cleanValue.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4',
      );
      return includeType ? `CPF: ${formattedCPF}` : formattedCPF;
    } else if (cleanValue.length === 14) {
      // Formata como CNPJ: 00.000.000/0000-00
      const formattedCNPJ = cleanValue.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      );
      return includeType ? `CNPJ: ${formattedCNPJ}` : formattedCNPJ;
    } else {
      return value.toString();
    }
  }
}
